import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SignPnContext } from '../SignPnEs'

const SignPnTerms = () => {
	const { t } = useTranslation()
	const { nextStep } = useContext(SignPnContext)
	const [pnTermsApproved, setPnTermsApproved] = useState<boolean>(false)

	return (
		<React.Fragment>
			<div className="sign-pn-approve-checkbox-section">
				<label className="checkbox-container">
					<input
						id="sign-promissory-note-confirm-checkbox"
						type="checkbox"
						className={`required-step ${
							pnTermsApproved ? 'completed-step' : ''
						}`}
						defaultChecked={pnTermsApproved}
						onClick={() => setPnTermsApproved(!pnTermsApproved)}
					/>
					<span className="checkmark"></span>
					<span className="text">
						{t('PromissoryNoteApproveTerms')}
					</span>
				</label>
			</div>
			<div className="sign-pn-button-section">
				<button
					id="sign-promissory-note-sign-contract-button"
					type="button"
					className="btn btn-primary"
					disabled={!pnTermsApproved}
					onClick={() => {
						setTimeout(() => {
							nextStep()
						}, 400)
					}}>
					{t('SIGNPN')}
				</button>
			</div>
		</React.Fragment>
	)
}
export default SignPnTerms